import { PageLayout } from '@all-manager/design-system-v2';
import { PropsWithChildren, ReactNode } from 'react';
import { useFullPageLayout } from './useFullPageLayout';

type Props = {
  htmlTitle: string;
  title: ReactNode;
  subtitle?: ReactNode;
  subtitlePosition?: 'top' | 'bottom';
  status?: ReactNode;
  action?: ReactNode;
  backLink?: string;
  fixedHeader?: boolean;
}

export default function FullPageLayout(props: PropsWithChildren<Props>) {
  const hook = useFullPageLayout(props);

  return (
    <PageLayout
        title={props.title}
        subtitle={props.subtitle}
        subtitlePosition={props.subtitlePosition}
        status={props.status}
        action={props.action}
        backHref={props.backLink}
        onBackClick={hook.handleBackClick}
        fixedHeader={props.fixedHeader}
      >
        {props.children}
      </PageLayout>
  );
};
